/**
 * Loader léger pour formulaires et actions HTMX non-boost.
 * Ne jamais appeler sur des navigations hx-boost.
 */
export function showLoading(element) {
    if (!element || element.tagName === 'BODY') return;
    element.dataset.loadingPrev = element.innerHTML;
    element.setAttribute('disabled', 'disabled');
    element.style.opacity = '0.7';
}

export function hideLoading(element) {
    if (!element || element.tagName === 'BODY') return;
    element.removeAttribute('disabled');
    element.style.opacity = '';
}